
import { defineComponent, computed } from 'vue'

export default defineComponent({
    name: 'BackgroundImage',
    props: {
        image: { type: String, default: 'landing' },
        position: { type: String, default: 'top' },
        height: { type: String, default: '80' },
        useParallax: { type: Boolean, default: false },
    },
    setup(props) {
        const backgroundImage = computed(() => {
            return require(`@/assets/images/${props.image}.jpg`)
        })

        const backgroundImageStyle = computed(() => {
            return `object-position: ${props.position}; height: ${props.height}vh;`
        })

        const backgroundImageOverlayStyle = computed(() => {
            return `height: ${props.height}vh;`
        })

        return {
            backgroundImage,
            backgroundImageStyle,
            backgroundImageOverlayStyle,
        }
    },
})
